import React, { useContext, useState } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { FormattedMessage, injectIntl } from "react-intl"
import { Button, CartContext } from ".."
import { Link } from "gatsby"
import back from "../../images/back.svg"
import FormControl from "@material-ui/core/FormControl"
import Input from "@material-ui/core/Input/Input"
import Cookies from "universal-cookie"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      paddingBottom: theme.spacing(3),
    },
  },
  gridSubtotal: {
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
    },
  },
  gridBorder: {
    margin: "24px 0",
    height: "1px",
    backgroundColor: theme.palette.black.supportLight,
  },
  checkoutButton: {
    width: "100%",
  },
  subtotalValue: {
    fontWeight: "600",
    textAlign: "right",
  },
  footerText: {
    textDecoration: "none",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.up("lg")]: {
      position: "relative",
    },
    [theme.breakpoints.down("md")]: {
      boxShadow: "0 -2px 16px 0 rgba(0,0,0,0.1)",
      padding: theme.spacing(3, 2.5),
    },
  },
  checkoutContainer: {
    flexBasis: "50%",
  },
  checkoutLink: {
    textDecoration: "none",
  },
  continueShopping: {
    flexBasis: "50%",
    textDecoration: "none",
    "& a, & a:visited, & a:active": {
      textDecoration: "none",
    },
  },
  shoppingButton: {
    marginRight: "1rem",
    textTransform: "uppercase",
    fontSize: "13px",
    color: theme.palette.green.main,
    paddingLeft: theme.spacing(1.7),
  },
  shoppingButtonLabel: {
    textAlign: "left",
  },
  shoppingLink: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
  },
  inputMargin: {
    marginTop: theme.spacing(3.25),
  },
  boxBordersFullWidth: {
    border: "1px solid #8A8B8C",
    height: "48px",
    padding: "0 16px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("xl")]: {
      marginRight: theme.spacing(6),
      width: "288px",
    },
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  promotionValue: {
    fontWeight: "600",
    textAlign: "right",
    marginTop: "35px !important",
  },
  hidden: {
    display: "none",
  },
  button: {
    height: "36px",
    fontFamily: theme.typography.fontFamily,
    fontSize: "13px",
  },
  buttonContainer: {
    textAlign: "right",
    paddingTop: "30px",
  },
  fixDiscount: {
    marginTop: "13px",
  },
  invalidPromo: {
    textFont: "10px",
    color: "red",
  },
}))

export default injectIntl(props => {
  const [emptyEmailMsg, setEmptyEmailMsg] = useState(false)
  const [emptyPromoMsg, setEmptyPromoMsg] = useState(false)
  const [invalidPromoMsg, setInvalidPromoMsg] = useState(false)
  const [eligibleMsg, setEligibleMsg] = useState(false)
  const [usedPromoMsg, setUsedPromoMsg] = useState(false)

  const [promo, setPromo] = useState("")

  const cookies = new Cookies()
  const classes = useStyles()
  let {
    subTotalValue,
    tax,
    taxedSubtotal,
    items,
    getFormattedPrice,
    addPromotion,
  } = useContext(CartContext)
  const { locale } = props.intl

  const getCustomerInfoAndAddPromo = (email, promoCode) => {
    let xhr = new XMLHttpRequest()
    xhr.open("POST", "https://ickr3dus78.execute-api.us-east-2.amazonaws.com/prod/customer", false)
    xhr.setRequestHeader("Content-Type", "application/json")
    xhr.onreadystatechange = async function() {
      if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
        const jsonData = JSON.parse(this.response)
        let isEligible = false
        let isUsedBefore = false

        if (jsonData.body.data.isPromoEligible) {
          isEligible = true
        }
        if (jsonData.body.data.usedPromo != null && jsonData.body.data.usedPromo.includes(promo)) {
          isUsedBefore = true
        }
        if (isEligible) {
          if (!isUsedBefore) {
            if (await addPromotion((promoCode) ? promoCode : promo)) {
              setEmptyEmailMsg(false)
              setEmptyPromoMsg(false)
              setInvalidPromoMsg(false)
              setEligibleMsg(false)
              setUsedPromoMsg(false)
              let discountPopupExpireDate = new Date
              discountPopupExpireDate.setFullYear(discountPopupExpireDate.getFullYear() + 10)
              cookies.set("customer_id", jsonData.body.data.id, { path: "/", expires: discountPopupExpireDate })
              if (promoCode) {
                cookies.set("used_promo", promoCode, { path: "/", expires: discountPopupExpireDate })
              } else {
                cookies.set("used_promo", promo, { path: "/", expires: discountPopupExpireDate })
              }
            } else {
              setEmptyEmailMsg(false)
              setEmptyPromoMsg(false)
              setInvalidPromoMsg(true)
              setEligibleMsg(false)
              setUsedPromoMsg(false)
            }
          } else {
            setEmptyEmailMsg(false)
            setEmptyPromoMsg(false)
            setInvalidPromoMsg(false)
            setEligibleMsg(false)
            setUsedPromoMsg(true)
          }
        } else {
          setEmptyEmailMsg(false)
          setEmptyPromoMsg(false)
          setInvalidPromoMsg(false)
          setEligibleMsg(true)
          setUsedPromoMsg(false)
        }
      }
    }
    const data = {
      email: email,
    }
    xhr.send(JSON.stringify(data))
  }

  const shippingItems = items.filter(item => {
    if (item.sku === "shipping") {
      return true
    }
    return null
  })

  const discountItem = items.filter(item => {
    if (item.type === "promotion_item") {
      return true
    }
    return null
  })

  let shippingValue = shippingItems[0]
    ? shippingItems[0].meta.display_price.with_tax.value.amount
    : 0

  subTotalValue = getFormattedPrice((subTotalValue - shippingValue) / 100)
  shippingValue = getFormattedPrice(shippingValue / 100)

  let discountValue = null
  if (discountItem.length > 0) {
    discountValue = getFormattedPrice(discountItem[0].value.amount / 100)
  }


  const handleClick = e => {
    if (props.isModal) {
      e.preventDefault()
      props.onClose()
    }
  }

  const handlePromoChange = event => {
    setPromo(event.target.value)
  }

  const handlePromoClick = async () => {
    if(promo === "PURA10"){
      if (cookies.get("emailAddress") == null || cookies.get("emailAddress") === "") {
        setEmptyEmailMsg(true)
        setEmptyPromoMsg(false)
        setInvalidPromoMsg(false)
        setEligibleMsg(false)
        setUsedPromoMsg(false)
      }
      else {
        await getCustomerInfoAndAddPromo(cookies.get("emailAddress"), null)
      }
    }
    else if (promo === "" || promo.trim().length === 0) {
      setEmptyEmailMsg(false)
      setEmptyPromoMsg(true)
      setInvalidPromoMsg(false)
      setEligibleMsg(false)
      setUsedPromoMsg(false)
    }
    else{
      if(await addPromotion(promo))
      {
        setEmptyEmailMsg(false)
        setEmptyPromoMsg(false)
        setInvalidPromoMsg(false)
        setEligibleMsg(false)
        setUsedPromoMsg(false)
      }
      else{
        setEmptyEmailMsg(false)
        setEmptyPromoMsg(false)
        setInvalidPromoMsg(true)
        setEligibleMsg(false)
        setUsedPromoMsg(false)
      }
    }
  }


  return (
    <div className={classes.root}>
      <div className={classes.gridBorder}></div>
      <Grid container className={classes.gridSubtotal}>
        <Grid item xs>
          <Typography>
            <FormattedMessage id="subtotal"/>
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography
            className={classes.subtotalValue}
            data-cy="subtotal-field"
          >
            {subTotalValue}
          </Typography>
        </Grid>
      </Grid>


      {props.isCheckout ? (
        <>
          {/* <Grid container className={classes.gridSubtotal}>
            <Grid item xs>
              <Typography>
                <FormattedMessage id="taxes" />
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.subtotalValue}>{tax}</Typography>
            </Grid>
          </Grid> */}

          <Grid container className={classes.gridSubtotal}>
            <Grid item xs>
              <Typography>
                <FormattedMessage id="shipping"/>
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.subtotalValue}>
                {shippingValue}
              </Typography>
            </Grid>
          </Grid>


          {discountValue === null && <Grid container
                                           className={classes.gridSubtotal}>
            <Grid item xs>
              <FormControl
                className={`${classes.formControl} ${classes.inputMargin}`}
                fullWidth
              >
                <FormattedMessage id="promoCode">
                  {msg => (
                    <Input
                      className={`${classes.formControl} ${classes.boxBordersFullWidth}`}
                      id="component-error"
                      aria-describedby="component-error-text"
                      fullWidth
                      name="promotion"
                      onChange={handlePromoChange}
                      value={promo}
                      placeholder={msg}
                    />
                  )
                  }
                </FormattedMessage>
                <p className={invalidPromoMsg ? classes.invalidPromo : classes.hidden}><FormattedMessage
                  id="wrongPromo"/>
                </p>
                <p className={emptyPromoMsg ? classes.invalidPromo : classes.hidden}><FormattedMessage id="noPromo"/>
                </p>
                <p className={eligibleMsg ? classes.invalidPromo : classes.hidden}><FormattedMessage id="notEligible"/>
                </p>
                <p className={usedPromoMsg ? classes.invalidPromo : classes.hidden}><FormattedMessage id="usedPromo"/>
                </p>
                <p className={emptyEmailMsg ? classes.invalidPromo : classes.hidden}><FormattedMessage
                  id="usedPromoEmailWarning"/></p>
              </FormControl>
            </Grid>
            <Grid item xs className={classes.buttonContainer}>
              <Button
                className={classes.button}
                color={"green"}
                onClick={handlePromoClick}
              >
                <FormattedMessage id="apply"/>
              </Button>
            </Grid>
          </Grid>
          }

          <Grid container
                className={discountValue !== null ? classes.gridSubtotal : classes.hidden}>
            <Grid item xs className={classes.fixDiscount}>
              <Typography>
                <FormattedMessage id="discount"/>
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography
                className={`${classes.promotionValue}`}
                data-cy="subtotal-field"
              >
                {discountValue}
              </Typography>
            </Grid>
          </Grid>


          <div className={classes.gridBorder}></div>
          <Grid container className={classes.gridSubtotal}>
            <Grid item xs>
              <Typography>Total</Typography>
            </Grid>
            <Grid item xs>
              <Typography
                className={classes.subtotalValue}
                data-cy="total-field"
              >
                {taxedSubtotal}
              </Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        <div className={classes.buttonsContainer}>
          <div className={classes.continueShopping}>
            <Link
              to={`/${locale}`}
              className={classes.shoppingLink}
              onClick={handleClick}
            >
              <img src={back} alt="Continue Shopping"/>
              <Button
                className={classes.shoppingButton}
                data-cy="checkout-button"
                color={"transparent"}
              >
                <Typography
                  variant="body2"
                  component="span"
                  className={classes.shoppingButtonLabel}
                >
                  <FormattedMessage id="continueShopping"/>
                </Typography>
              </Button>
            </Link>
          </div>
          <div className={classes.checkoutContainer}>
            <Link to={`/${locale}/checkout`} className={classes.checkoutLink}>
              <Button
                className={classes.checkoutButton}
                data-cy="checkout-button"
                color={"green"}
              >
                <FormattedMessage id="checkout"/>
              </Button>
            </Link>
          </div>
        </div>
      )}
    </div>
  )
})
